<script>
import { mapActions } from 'vuex';

export default {
  name: 'SkiPassWrapper',
  methods: {
    ...mapActions({
      resetState: 'skischool/resetState',
    }),
  },
  destroyed() {
    this.resetState();
  },
};
</script>

<template>
  <v-content>
    <router-view></router-view>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/ski/skipass/SkiPassWrapper.vue